
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M82.326 29.633h-2.722v-5.176a5.928 5.928 0 00-5.876-5.966H18.994a5.928 5.928 0 00-5.876 5.966v34.818a5.928 5.928 0 005.876 5.966h18.581v4.571l-2.057 4.732a1 1 0 00.917 1.4h19.05a1 1 0 00.903-1.432l-2.257-4.719v-4.552h3.138v11.5a4.671 4.671 0 004.556 4.768h20.5a4.671 4.671 0 004.557-4.768V34.4a4.671 4.671 0 00-4.556-4.768zM59.269 39.34h25.613v33.32H59.27zm25.613-4.937v2.937H59.27v-2.937a2.672 2.672 0 012.556-2.769h20.5a2.672 2.672 0 012.557 2.769zM18.994 20.49h54.734a3.926 3.926 0 013.876 3.966v5.176h-15.78a4.671 4.671 0 00-4.555 4.769v20.704H15.118v-30.65a3.926 3.926 0 013.876-3.965zM52.23 70.45l1.67 3.492H37.96l1.532-3.524a1.002 1.002 0 00.083-.399v-4.78h12.556v4.78a1 1 0 00.098.432zm-33.235-7.21a3.926 3.926 0 01-3.876-3.966v-2.169h42.15v6.135zm63.332 16.268H61.825a2.672 2.672 0 01-2.556-2.768v-2.082h25.613v2.082a2.672 2.672 0 01-2.556 2.768z"}})])
          )
        }
      }
    